var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophoneAudioRecording(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fd2699"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ce0968"
    },
    d: "M300.982,89.459c-20.958,42.682-40.024,89.285-84.632,106.205 c-20.687,8.62-46.545,10.343-63.785,27.582c3.448,1.724,6.896,3.448,8.62,6.896c5.172,27.583-5.172,55.165,10.343,79.3 c20.687,34.478,63.785,36.202,93.091,62.061c-1.724,0-3.448-3.448-5.172,0c-1.724,18.963,6.896,41.374-3.448,53.441 c-13.755,12.84-32.644,17.106-51.548,21.34l65.322,65.345c121.141-6.423,219.926-97.061,238.913-214.442L300.982,89.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9ed2"
    },
    d: "M355.125,200.268H156.875c-4.284,0-7.758,3.474-7.758,7.758v49.562 c0,56.323,43.801,102.578,99.125,106.57v46.211h-29.789c-11.424,0-20.687,9.263-20.687,20.687s9.263,20.687,20.687,20.687h75.095 c11.424,0,20.687-9.263,20.687-20.687s-9.263-20.687-20.687-20.687h-29.791v-46.211c55.324-3.991,99.125-50.247,99.125-106.57 v-49.562C362.882,203.742,359.408,200.268,355.125,200.268z M347.367,257.588c0,50.381-40.986,91.367-91.367,91.367 s-91.367-40.986-91.367-91.367v-41.805h182.734V257.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdbea"
    },
    d: "M355.125,200.268h-99.699v15.515h91.941v41.805c0,50.381-40.986,91.367-91.367,91.367 c-0.193,0-0.381-0.014-0.574-0.014v102.802h38.121c11.424,0,20.687-9.263,20.687-20.687s-9.263-20.687-20.687-20.687h-29.789 v-46.211c55.324-3.991,99.125-50.247,99.125-106.57v-49.562C362.882,203.742,359.408,200.268,355.125,200.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdbea"
    },
    d: "M256,322.919L256,322.919c34.838,0,63.079-28.241,63.079-63.079V133.68 c0-34.838-28.241-63.079-63.079-63.079l0,0c-34.838,0-63.079,28.241-63.079,63.079v126.159 C192.921,294.678,221.162,322.919,256,322.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9ed2"
    },
    d: "M256,70.603L256,70.603c-0.193,0-0.383,0.012-0.574,0.014v252.288 c0.191,0.002,0.381,0.014,0.574,0.014l0,0c34.838,0,63.079-28.241,63.079-63.079V133.68C319.079,98.844,290.838,70.603,256,70.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9ed2"
    },
    d: "M192.921,230.529v29.31c0,34.838,28.241,63.079,63.079,63.079l0,0 c34.838,0,63.079-28.241,63.079-63.079v-29.31H192.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdbea"
    },
    d: "M255.426,230.529v92.374c0.191,0.002,0.381,0.014,0.574,0.014l0,0 c34.838,0,63.079-28.241,63.079-63.079v-29.31h-63.653V230.529z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneAudioRecording);
export default __webpack_public_path__ + "static/media/microphone-audio-recording.07d9e2eb02ceb2a8bcc4a586927d39a7.svg";
export { ForwardRef as ReactComponent };